import type {FC, ReactNode} from 'react'
import {Alert} from '@mui/material'

interface Props {
  children: ReactNode
}

const ErrorBubble: FC<Props> = ({children}) => {
  return (
    <Alert
      severity="error"
      // variant="outlined"
      sx={{
        alignSelf: 'flex-start',
        borderRadius: 2,
      }}
    >
      {children}
    </Alert>
  )
}

export default ErrorBubble
